(() => {
  const iconPlayer = document.querySelector('#iconLottiePlayer')
  const itemsToFadeIn = document.querySelectorAll('.vcontent .fademein')

  iconPlayer.addEventListener('complete', () => {
    // next block of code executes when icon animation is completed
    itemsToFadeIn.forEach(item => {
      item.style.opacity = 1;
    })
  })
})()